/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react'
import { YDivider, XDivider, useTheme, makeStyles } from 'irmlib/styles'
import styled from 'styled-components'
import { useMergeState } from '../../../../irmlib/src/hooks'
// import Table from '../../../Controls/Table'
import MuiDataTable from '../../../Controls/MuiDataTable'
import { Link, useHistory } from 'react-router-dom'
import { ContainedButton, Label, MenuButton, OutlinedButton, CheckBox } from 'irmlib/components/Controls'
import { getUser } from '../../../../redux/global'
import * as routePaths from '../../../../navigation/routePaths'
import * as gdeTrancactions from '../../../../services/firestore/gdeTransactions'
import * as gdeTransactionsLite from '../../../../services/firestore/gdeTransactionsLite'
import PropTypes from 'prop-types'
import moment from 'moment'
import { MoreVert } from 'irmlib/icons'
// import { uiGet } from 'irmlib//http'
import { clearBusy, setBusy, closeGeneralDialog, openGeneralDialog } from '../../../../irmlib/src/containers'
import { userRoleSupervisor, defaultDateFormat } from '../../../../common/constants'
import * as constants from 'irmlib/common/constants'
import { errorToast, successToast } from '../../../../common/functions'
import { jobStatus, today, getMonth } from '../../../../irmlib/src/common'
import { totalNoOfBoxesForJob } from '../../../../services/common/appConstants'
import { Grid, Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import TopButtons from './TopButtons'
import { DateTime } from '../../../../irmlib/src/components/FormControls'

const BottomPaddedDiv = styled('div')`
  padding-bottom: 20px;
`

const TableContainer = styled(BottomPaddedDiv)`
`


const JobLink = styled(Link)`
  color: ${props => props.theme.palette.primary.main};
  text-decoration: none;
`

const minWidth = '100px'

const useStyles = makeStyles({
  disabledState: {
    pointerEvents: 'none',
    opacity: '0.4'
  },
  startButton: {
    textDecoration: 'none'
  }
})

const initialState = {
  selectedData: [],
}

const AllOpenJobsData = (props) => {
  const [, setState, getState] = useMergeState(initialState)
  const { t } = useTranslation()
  const Filtervalue = props.filterData
  const classes = useStyles()
  const theme = useTheme()
  // const [refresh, setRefresh] = React.useState(false)
  const [allowCancelJob, setAllowCancelJob] = React.useState(false)
  // const [Alldata, setData] = React.useState([])
  const [defaultStatus, setDefaultStatus] = useState([])
  // Here, useRef is used instead of useState to prevent unwanted rerendering.
  const Alldata = useRef([])

  const updateState = (newValue) => {
    Alldata.current = newValue
  }
  const history = useHistory()


  useEffect(() => {
    const additionalGivenPermissions = window?.sessionStorage?.getItem('additional-permissions-user')
    if (additionalGivenPermissions !== 'undefined' && additionalGivenPermissions !== undefined && userRoleSupervisor) {
      const additionalPermissionsForUser = JSON.parse(additionalGivenPermissions)
      const indexOfEditJob = additionalPermissionsForUser?.map(object => object?.value)?.indexOf('editJob')

      if (additionalPermissionsForUser[indexOfEditJob]?.enabled) {
        setAllowCancelJob(userRoleSupervisor)
      }                              
    }
  }, [])

  useEffect(() => {
    let statuses = []
    if (props.searchParams) {
      statuses = [t(`jobStatusObj.${props.searchParams}`)]
    } else {
      statuses = constants.activeJobStatus.map(data => {
        return t(`jobStatusObj.${data}`)
      })
    }
    setDefaultStatus(statuses)
  }, [t])
  const showUsers = (obj) => {
    const names = []
    for (const key in obj) {
      if (obj[key].workerName !== undefined && obj[key].jobCategory.includes('Data Entry User')) {
        names.push(obj[key].workerName)
      }
    }
    return names.join(',')
  }

  const dataRet = async (val) => {
    const dataQuery = async (val) => {
      setBusy()
      const coll = await gdeTransactionsLite.getQueryDataJob2(val)
      const val3 = []
      coll.forEach((doc) => {
        if (val.createDateFrom !== constants.defaultSelect || val.createDateTo !== constants.defaultSelect || val.userName !== '--Select--') {
          const docData = doc.data()
          const assignedUserList = docData?.assignedUserList
          let isValid = true
          const createDateJob = moment(docData.createdTs.seconds, 'X').format(defaultDateFormat)
          const createDateFromFilter = moment(val.createDateFrom).format(defaultDateFormat)
          const createDateToFilter = moment(val.createDateTo).format(defaultDateFormat)
          const convtCreateDateJob = new Date(createDateJob).getTime()
          const convtCreateDateFrom = new Date(createDateFromFilter).getTime()
          const convtCreateDateTo = new Date(createDateToFilter).getTime()
          if (val.createDateFrom !== constants.defaultSelect && val.createDateTo !== constants.defaultSelect) {
            if (convtCreateDateFrom > convtCreateDateJob || convtCreateDateTo < convtCreateDateJob) {
              isValid = false
            }
          } else if (val.createDateFrom !== constants.defaultSelect) {
            if (convtCreateDateFrom > convtCreateDateJob) {
              isValid = false
            }
          } else if (val.createDateTo !== constants.defaultSelect) {
            if (convtCreateDateTo < convtCreateDateJob) {
              isValid = false
            }
          }

          if (val.userName !== '--Select--') {
            if (assignedUserList !== undefined) {
              if (!assignedUserList.includes(val.userName)) {
                isValid = false
              } 
            } else if (assignedUserList === undefined) {
              isValid = false
            }
          }

          if (isValid) {
            pushData(doc, val3)
          }
        } else {
          pushData(doc, val3)
        }
      })
      updateState(val3)
      // setData(val3)
      clearBusy()
      return val3
    }
    return await dataQuery(val)
  }

  const pushData = (doc, val) => {
    let totalNoOfBoxes = 0
    if (doc.data().totalBoxes === totalNoOfBoxesForJob) {
      totalNoOfBoxes = '-'
    } else {
      totalNoOfBoxes = parseInt(doc.data().totalBoxes)
    }

    val.push({
      jobId: doc.id,
      status: doc.data().jobStatus,
      status1: doc.data().jobStatus,
      boxes: totalNoOfBoxes,
      dateCreated: doc.data().createdTs ? moment(doc.data().createdTs.seconds, 'X').format('YYYY-MM-DD') : '0000-00-00',
      dataEntryUser: doc?.data()?.workerName?.join(', ') || showUsers(doc?.data()?.assignedUsers),
      boxesCompleted: doc.data().boxesCompleted ? doc.data().boxesCompleted : 0,
      targetDate: doc.data().targetDate ? moment(doc.data().targetDate.seconds, 'X').format('YYYY-MM-DD') : '0000-00-00',
      autoTransmit: (doc.data().autoTransmit === undefined) ? 'true' : doc.data().autoTransmit,
      manualTransmit: (doc.data().autoTransmit === undefined) ? 'false' : (doc.data().autoTransmit === 'true') ? 'false' : 'true',
      orderNumber: doc.data().orderNumber,
      jobType: doc.data().dataEntryType,
      jobType1: doc.data().dataEntryType
    })
  }

  const handleCalcelDeleteBox = () => {
    closeGeneralDialog()
  }


  const handleDelete = async (data) => {
    const metrics = await gdeTrancactions.getJobMetrics(data.jobId)
    metrics.forEach((doc) => {
      gdeTrancactions.deleteJobMetrics(doc.id)
    })
    gdeTrancactions.deleteJob(data.jobId, data.jobType, getUser().workerId)
    errorToast({
      message: t('toast.jobDeleted',
        { jobId: data.jobId }),
      title: t('toast.jobDeletedTitle'),
      autoHideDuration: 6000,
      isBlocking: false, 
      closeIcon: true 
    })
    // setRefresh(value => !value)
    closeGeneralDialog()
  }

  const handleCopyJob = async (jobId) => {
    history.push(`${routePaths.createJob}/${jobId}`)
    closeGeneralDialog()
  }

  const handleCanceldata = (rowdata, data) => {
    gdeTrancactions.updateJob(rowdata, data)
    successToast({ message: t('toast.cancelJobMessage'), title: t('toast.jobManagement') })
    // setRefresh(prevState => !prevState)
    closeGeneralDialog()
  }
  const ContentForDeleteBox = (props) => (
    <>
      <span><Label id={'allJobs_deleteButton_deleteContent1'} >Search.DeleteBoxContent1</Label>{props.jobId}</span>
      <Label id={'allJobs_deleteButton_deleteContent2'} >Search.DeleteBoxContent2</Label>
      <VerticalDivider />
      <Label id={'allJobs_deleteButton_deleteContent3'} >Search.DeleteBoxContent3</Label>
      <VerticalDivider />
    </>
  )
  const ContentForCancelBox = (props) => (
    <>
      <Label id={'allJobs_deleteButton_deleteContent1'} >Search.cancelBoxContent1</Label>
      <Label id={'allJobs_deleteButton_deleteContent2'} >Search.cancelBoxContent2</Label>
      <VerticalDivider />
    </>
  )
  const ContentForCopyJob = (props) => (
    <>
      <Label id={'allJobs_deleteButton_deleteContent1'} >Search.copyJobContentMessage</Label>
      <VerticalDivider />
    </>
  )
  const DeleteBox = (props) => (
    <>
      <VerticalDivider />
      <XDivider width="25px" />
      <OutlinedButton id={'allJobs_deleteButton_cancel'}noTranslate style={{ minWidth }} onClick={props.handleCancel} >Search.Cancel</OutlinedButton>
      <ContainedButton id={'allJobs_deleteButton_yes'} style={{ minWidth }} onClick={props.handleDelete}>Search.yes</ContainedButton>
      <VerticalDivider />
      <XDivider width="25px" />
    </>
  )

  const CopyJob = (props) => (
    <>
      <VerticalDivider />
      <XDivider width="25px" />
      <OutlinedButton id={'allJobs_deleteButton_cancel'} style={{ minWidth }} onClick={props.handleCancel} >Search.Cancel</OutlinedButton>
      <ContainedButton id={'allJobs_deleteButton_yes'} style={{ minWidth }} onClick={props.handleCopyJob}>Search.yes</ContainedButton>
      <VerticalDivider />
      <XDivider width="25px" />
    </>
  )

  const CancelBox = (props) => (
    <>
      <VerticalDivider />
      <XDivider width="25px" />
      <OutlinedButton id={'allJobs_deleteButton_cancel'} style={{ minWidth }} onClick={props.handleCancel} >Search.Cancel</OutlinedButton>
      <ContainedButton id={'allJobs_deleteButton_yes'} style={{ minWidth }} onClick={props.handleDelete}>Search.yes</ContainedButton>
      <VerticalDivider />
      <XDivider width="25px" />
    </>
  )
  CopyJob.propTypes = {
    handleCancel: PropTypes.func,
    handleCopyJob: PropTypes.func
  }
  DeleteBox.propTypes = {
    handleCancel: PropTypes.func,
    handleDelete: PropTypes.func
  }
  CancelBox.propTypes = {
    handleCancel: PropTypes.func,
    handleDelete: PropTypes.func
  }

  // const getPageData = async (page, pageSize) => {
  //   return await uiGet({ service: () => dataRet(value) })
  // }
  const getPageData = async (page, pageSize) => {
    try {
      const data = await dataRet(Filtervalue)
      return data
    } catch (error) {
      // eslint-disable-next-line
      console.error('Error fetching page data:', error)
      return []
    }
  }

  const openDeleteBoxDialog = (rowdata) => {
    openGeneralDialog({
      title: t('Search.DeleteJob'),
      noTranslateTitle: true,
      message: <ContentForDeleteBox jobId={rowdata.jobId}/>,
      closeX: true,
      buttons: (
        <DeleteBox
          handleCancel={handleCalcelDeleteBox}
          handleDelete={() => handleDelete(rowdata)}
        />
      )
    })
    return Promise.resolve()
  }


  const openCancelBoxDialog = (rowdata, data) => {
    openGeneralDialog({
      title: t('Search.CancelJob'),
      noTranslateTitle: true,
      message: <ContentForCancelBox />,
      closeX: true,
      buttons: (
        <CancelBox
          handleCancel={handleCalcelDeleteBox}
          handleDelete={() => handleCanceldata(rowdata, data)}
        />
      )
    })
    return Promise.resolve()
  }


  const openCopyJobDialog = (jobId) => {
    openGeneralDialog({
      title: t('Search.CopyJob'),
      noTranslateTitle: true,
      message: <ContentForCopyJob />,
      closeX: true,
      buttons: (
        <CopyJob
          handleCancel={handleCalcelDeleteBox}
          handleCopyJob={() => handleCopyJob(jobId)}
        />
      )
    })
    return Promise.resolve()
  }

  const closeJob = async(jobId, qtyOfBoxes, manualTransmit) => {
    // eslint-disable-next-line
    const autoTransmit = manualTransmit === 'true' ? false : true
    const dataForCloseJob = {
      totalBoxes: qtyOfBoxes,
      jobStatus: 'Transmitted',
      autoTransmitAndStatus: `${autoTransmit}-${constants.jobStatus.transmitted}`,
      isClosedJob: true,
      isClosedJobTs: new Date()
    }
    await gdeTrancactions.updateJob(jobId, dataForCloseJob)
    closeGeneralDialog()
    successToast({ message: t('toast.jobClosed', { jobId: jobId }), autoHideDuration: 3000 })
  }

  const ButtonsForCloseJob = (props) => {
    return (
      <>
        <OutlinedButton onClick={closeGeneralDialog}>buttons.no</OutlinedButton>
        <ContainedButton onClick={() => closeJob(props.jobId, props.qtyOfBoxes, props.manualTransmit)}>buttons.yes</ContainedButton>
      </>
    )
  }

  const handleCloseJob = async(rowdata) => {
    if (rowdata.status1 === constants.jobStatus.assigned || rowdata.status1 === constants.jobStatus.pending) {
      openGeneralDialog({
        title: t('Search.CloseJob'),
        noTranslateTitle: true,
        message: t('messages.pendingAssignedCloseJobsMsg'),
        buttons: <OutlinedButton onClick={closeGeneralDialog}>buttons.cancel</OutlinedButton>
      })
    }
    if (rowdata.status1 === constants.jobStatus.transmitted) {
      openGeneralDialog({
        title: t('Search.CloseJob'),
        noTranslateTitle: true,
        message: t('messages.transmittedCloseJobMsg'),
        buttons: <OutlinedButton onClick={closeGeneralDialog}>buttons.cancel</OutlinedButton>
      })
    }
    if (rowdata.status1 === constants.jobStatus.inProgress || rowdata.status1 === constants.jobStatus.readyToTransmit) {
      let readyToClose = true
      const BoxesData = await gdeTrancactions.getBoxesForJob(rowdata.jobId)
      const qtyOfBoxes = BoxesData.docs.length
      let qtyOfBoxesRemaining = 0
      const jobId = rowdata.jobId
      const manualTransmit = rowdata.manualTransmit
      BoxesData.forEach((doc) => {
        const boxData = doc.data()
        if (!(boxData.status === constants.boxStatus.transmitted || boxData.status === constants.boxStatus.exception)) {
          readyToClose = false
          qtyOfBoxesRemaining += 1
        }
      })
      if (readyToClose) {
        openGeneralDialog({
          title: t('Search.CloseJob'),
          noTranslateTitle: true,
          message: t('messages.closeJob'),
          buttons: <ButtonsForCloseJob jobId={jobId} qtyOfBoxes={qtyOfBoxes} manualTransmit={manualTransmit} />
        })
      } 
      if (!readyToClose) {
        openGeneralDialog({
          title: t('Search.CloseJob'),
          noTranslateTitle: true,
          message: t('messages.closeJobInProcessMsg', { qtyOfBoxesRemaining: qtyOfBoxesRemaining }),
          buttons: <OutlinedButton onClick={closeGeneralDialog}>buttons.cancel</OutlinedButton>
        })
      }
    }
  }

  const onSelect = (value, rowdata) => {
    const data = {
      jobStatus: constants.jobStatus.cancel,
      autoTransmitAndStatus: `${rowdata.autoTransmit}-${constants.jobStatus.cancel}`,
    }
    if (value === 'Delete') {
      openDeleteBoxDialog(rowdata)
    } else if (value === 'CancelJob') {
      openCancelBoxDialog(rowdata.jobId, data)
    } else if (value === 'CopyJob') {
      openCopyJobDialog(rowdata.jobId)
    } else if (value === 'CloseJob') {
      handleCloseJob(rowdata)
    }
  }

  const handleStatusFilterChange = (changedColumn, filterList, type, changedColumnIndex, displayData) => {
    if (getState()?.selectedData.length !== 0) {
      history.push(`${routePaths.AllOpenJobs}`)
      setState({ selectedData: [] })  
    }
    if (changedColumn === 'status') {
      if (JSON.stringify(filterList) !== JSON.stringify(defaultStatus)) {
        setDefaultStatus(filterList[changedColumnIndex])
      }
    }
  }

  const columns = [
    { 
      label: t('tableColumns.jobId'), 
      name: 'jobId',
      options: {
        customBodyRenderLite: (dataIndex) => {
          const rowdata = Alldata.current[dataIndex]
          return (
            <JobLink id={`allJobs_jobLink_${rowdata?.jobId}`} className={rowdata?.status1 === constants.jobStatus.cancel ? classes.disabledState : null} theme={theme} to={{ pathname: `${routePaths.boxList}/${rowdata?.jobId}`, state: { fromAdmin: true } }}>
              {rowdata?.jobId}
            </JobLink>
          )
        },
        filter: false,
      },
      
    }, 
    { 
      label: t('tableColumns.status'), 
      name: 'status', 
      options: {
        filterType: 'multiselect',
        filterList: defaultStatus,
      }
    }, 
    { 
      label: t('tableColumns.dateCreated'),
      name: 'dateCreated',
      options: {
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <DateTime
              label= {t('tableColumns.dateCreated')}
              type='month'
              minDate={getMonth('2020-01')}
              maxDate= {getMonth(today())}
              onChange={(selectedMonth) => {
                const updatedFilterList = [...filterList]
                updatedFilterList[index] = selectedMonth ? [selectedMonth] : []
                onChange(updatedFilterList[index], index, column)
              }}
            />
          ),
          logic: (rowData, filterValue) => {
            if (filterValue && filterValue.length) {
              const filterMonth = filterValue[0]
              return !rowData.includes(filterMonth)
            } else {
              return false
            }
          }
        },
      },
    }, 
    { 
      label: t('tableColumns.dataEntryUser'),
      name: 'dataEntryUser'
    },
    { 
      label: t('tableColumns.boxes'), 
      name: 'boxes',
      options: {
        filter: false
      }
    },
    { 
      label: t('tableColumns.boxesTransmitted'), 
      name: 'boxesCompleted',
      options: {
        filter: false
      }
    },
    { 
      label: t('tableColumns.targetCompletionDate'), 
      name: 'targetDate',
      options: {
        filter: false
      }
    },
    { 
      label: t('tableColumns.manualTransmit'), 
      name: 'manualTransmit',
      options: {
        filterType: 'dropdown',
        filterOptions: {
          names: [t('Search.Yes'), t('Search.No')],
          logic: (rowData, filterValue) => {
            if (filterValue[0] === t('Search.Yes')) {
              return rowData !== 'true'
            } else if (filterValue[0] === t('Search.No')) {
              return rowData !== 'false'
            } else {
              return false
            }
          }
        },
        customBodyRenderLite: (dataIndex) => {
          return (
            <CheckBox disabled checked={(Alldata.current[dataIndex]?.manualTransmit === 'true')} />
          )
        }
      },
    },
    { 
      label: t('tableColumns.orderNumber'), 
      name: 'orderNumber',
      options: {
        filterType: 'textField',
      }
    },
    { 
      label: t('tableColumns.type'), 
      name: 'jobType'
    },
    {
      name: 'modify',
      label: t('tableColumns.action'),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          const rowData = Alldata.current[dataIndex]
          if (!rowData) return null
          return (
            <MenuButton
              id={'allJobs_ellipsis'}
              buttonIcon={<MoreVert />}
              rowdata={rowData}
              items={rowData === jobStatus.transmitted || rowData.boxesCompleted !== 0 ? allowCancelJob === 'SUPERVISOR' ? menuItemsSupervisor : menuItems1 : allowCancelJob === 'SUPERVISOR' ? menuItemsSupervisor : menuItems}
              onSelect={(value) => { onSelect(value, rowData) }}
            />
          )
        }
      }
    }
  ]

  const menuItems = [
    { value: 'CancelJob', id: 'createJobs_edit', label: t('Search.CancelJob'), style: { color: theme.palette.primary.main } },
    { value: 'Delete', label: t('Search.Delete'), style: { color: theme.palette.primary.main } },
    { value: 'CopyJob', label: t('Search.CopyJob'), style: { color: theme.palette.primary.main } },
    { value: 'CloseJob', label: t('Search.CloseJob'), style: { color: theme.palette.primary.main } },
  ]

  const menuItems1 = [
    { value: 'CancelJob', id: 'createJobs_edit', label: t('Search.CancelJob'), style: { color: theme.palette.primary.main } },
    // { value: 'Delete', label: 'Search.Delete', style: { color: theme.palette.primary.main } },
    { value: 'CopyJob', label: t('Search.CopyJob'), style: { color: theme.palette.primary.main } },
    { value: 'CloseJob', label: t('Search.CloseJob'), style: { color: theme.palette.primary.main } },
  ]

  const menuItemsSupervisor = [
    { value: 'CancelJob', id: 'createJobs_edit', label: t('Search.CancelJob'), style: { color: theme.palette.primary.main } },
    { value: 'CopyJob', label: t('Search.CopyJob'), style: { color: theme.palette.primary.main } },
    { value: 'CloseJob', label: t('Search.CloseJob'), style: { color: theme.palette.primary.main } },
  ]

  const VerticalDivider = () =>
    <YDivider height='25px' />

  const options = {
    filterType: 'dropdown',
    // selectableRows: 'single',
    selectableRowsHeader: false,
    selectToolbarPlacement: 'none',
    elevation: 0,
    page: 0,
    responsive: 'standard',
    tableBodyMaxHeight: '700px', // this is to implement the in-table scrolling 
    onFilterChange: handleStatusFilterChange,
    // sortOrder: {
    //   name: 'dateCreated',
    //   direction: 'desc'
    // },
    onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
      if (allRowsSelected.length === 0) {
        setState({ selectedData: [] })
      } else {
        // storing the rowdata of the jobs selected for transmission in selectedData
        const newSelectedData = allRowsSelected.map(row => {
          const rowData = Alldata.current[row.dataIndex]
          return rowData
        })
        setState({ selectedData: newSelectedData })
      }
    },
    customRowOptions: (rowData, rowMeta) => {
      return (
        <MenuButton
          id={'allJobs_ellipsis'}
          buttonIcon={<MoreVert />}
          rowData={rowData}
          items={
            rowData.status1 === jobStatus.transmitted || rowData.boxesCompleted !== 0 
              ? allowCancelJob === 'SUPERVISOR' 
                ? menuItemsSupervisor 
                : menuItems1 
              : allowCancelJob === 'SUPERVISOR' 
                ? menuItemsSupervisor
                : menuItems}
          onSelect={(value) => { onSelect(value, rowData) }}
        />
      )
    },
  }
  return (
    <>
      <TableContainer>
        <Box boxShadow={3} borderRadius={4}>
          <Grid item container xs={12} md={12} sx={{ padding: '20px 20px 0px' }}>
            <Grid item container xs={12} md={4} alignItems={'center'}>
              <Typography variant='h6'>
                {t('routeTitles.openJobs')}
              </Typography>
            </Grid>
            <Grid item container xs={12} md={8} justifyContent="end">
              <TopButtons selectedData={getState().selectedData} id={'AllJobs_topButtons'} />
            </Grid>
          </Grid>
          <MuiDataTable
            prop={props}
            data={getPageData}
            columns={columns}
            options={options}
          />
        </Box>
      </TableContainer>
    </>
  )
}
AllOpenJobsData.propTypes = {
  filterData: PropTypes.object,
  searchParams: PropTypes.string
}

export default AllOpenJobsData
